/* eslint-disable @sas/i18n/jsx-to-localize */
export const SUBSCRIBE_ALL = '*';
export const APP_ADDED = 'AppSwitcher.AppAdded';
export const APP_DATA_LOADED = 'AppSwitcher.AppDataLoaded';
export const CREATE = 'App.Create';
export const DIRTY_FLAG_CHANGED = 'AppSwitcher.DirtyFlagChanged';
export const HIDE = 'AppSwitcher.AppHide';
export const LOGOFF_IMMINENT = 'AppSwitcher.LogoffImminent';
export const PREFERENCE_CHANGED = 'AppSwitcher.PreferenceChanged';
export const OPEN = 'App.Open';
export const RETURN = 'AppSwitcher.AppReturn';
export const SHOW = 'AppSwitcher.AppShow';
export const SWITCH = 'AppSwitcher.AppSwitch';
export const UPDATE_MODEL = 'AppSwitcher.AppInfoChanged';
export const USE_NOVA_APPSWITCHER = 'AppSwitcher.UseNovaAppswitcher';
/* eslint-disable @sas/i18n/jsx-to-localize */

class ApplicationSwitcherObservable {
  handlers = [];
  subscribe(type, fn, context) {
    this.handlers.push({
      type,
      fn,
      context
    });
  }
  unsubscribe(type, fn, context) {
    this.handlers = this.handlers.filter(handler => {
      if (!this.isSameHandler(handler, {
        fn,
        type,
        context
      })) {
        return handler;
      }
    });
  }
  isSameHandler(handler1, handler2) {
    if (handler1.fn === handler2.fn && handler1.type === handler2.type && handler1.context === handler2.context) {
      return true;
    }
    return false;
  }
  fire(type, data = {}) {
    for (const handler of this.handlers) {
      if (handler.type === SUBSCRIBE_ALL || handler.type === type) {
        handler.fn.call(handler.context || this, type, data);
      }
    }
  }
}
export default ApplicationSwitcherObservable;
//# sourceMappingURL=ApplicationSwitcherObservable.js.map